import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function FAQ() {
    return (
      <div>
      <Typography variant="h6" align='left' gutterBottom={true}>FQA</Typography>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography variant="button">What should I do if the blank page shows?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
               Please turn off the broswer translation function if it's on.
               </Typography>
               <Typography>
               Try refresing page by holding down 'Command'(Mac)/'Control'(Windows) + 'Shift' + the 'R' key. 
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography variant="button">"502 invalid" pops up in the country select question</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography >
              Please refesh the page and try agagin.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3a-content"
            id="panel3a-header"
          >
            <Typography variant="button">Can't advance after pressing "continue"/"complete" button</Typography>
          </AccordionSummary>
          <AccordionDetails>
              Please refresh the page, try clicking the "continue"/"complete" button <Typography display="inline" style={{color: 'red',fontWeight:'bold'}}> only once </Typography>when finishing the current survey page.
          </AccordionDetails>
        </Accordion>
      </div>
    );
  }
